import { mean } from "d3-array";
import { last, slidingWindow } from "../utils";
import { CCI as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize } = options;

    const cciAlgorithm = slidingWindow()
      .windowSize(windowSize)
      .accumulator((values) => {
        // Calculate Typical Price for each period
        const typicalPrices = values.map((d) => (d.high + d.low + d.close) / 3);

        // Calculate SMA of Typical Price
        const smaTP = mean(typicalPrices);

        // Calculate Mean Deviation
        const deviations = typicalPrices.map((tp) => Math.abs(tp - smaTP));
        const meanDeviation = mean(deviations);

        // Calculate CCI
        const currentTP =
          (last(values).high + last(values).low + last(values).close) / 3;
        const cci = (currentTP - smaTP) / (0.015 * meanDeviation);

        return cci;
      });

    return cciAlgorithm(data);
  }

  calculator.options = function (x) {
    if (!arguments.length) return options;
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  calculator.undefinedLength = function () {
    const { windowSize } = options;
    return windowSize - 1;
  };

  return calculator;
}
